import { RevealGroup, RevealItem } from "@/components/motion/motion";
import { cn } from "@/lib/utils";

/**
 * Short numbered arguments (title + sentence) between rules: three columns
 * under a scene, or a stacked list beside one.
 */
export function NumberedPoints({
	items,
	title,
	columns = false,
	className,
}: {
	items: Record<string, { title: string; description: string }>;
	title?: string;
	columns?: boolean;
	className?: string;
}) {
	return (
		<div className={className}>
			{title ? (
				<h3 className="mb-6 font-mono text-xs font-medium tracking-[0.06em] text-muted-foreground uppercase">
					{title}
				</h3>
			) : null}
			<RevealGroup
				as="ol"
				className={cn(
					"border-t",
					columns && "md:grid md:grid-cols-3 md:divide-x md:divide-border",
				)}
			>
				{Object.entries(items).map(([key, item], index) => (
					<RevealItem
						as="li"
						key={key}
						className={cn(
							"grid grid-cols-[2.5rem_minmax(0,1fr)] border-b py-6",
							columns &&
								"md:block md:border-b-0 md:px-8 md:py-8 md:first:pl-0 md:last:pr-0",
						)}
					>
						<span className="font-mono text-xs text-signal-ink">
							{String(index + 1).padStart(2, "0")}
						</span>
						<div className={cn(columns && "md:mt-3")}>
							<p className="text-lg font-semibold tracking-tight">
								{item.title}
							</p>
							<p className="mt-1.5 text-pretty text-muted-foreground">
								{item.description}
							</p>
						</div>
					</RevealItem>
				))}
			</RevealGroup>
		</div>
	);
}
